import apiUrl from './api';
import { postWithAuth } from '@/lib/httpAdapter';

const onboardingStatusEndpoint = `${apiUrl}getInternalOnboardingCodeReview/`;
const onboardingCompleteEndpoint = `${apiUrl}setInternalOnboardingCodeReview/`;

export interface CodeReviewOnboardingStatusRequest {
  OrgUUID: string;
}

export interface CodeReviewOnboardingStatusResponse {
  value: number;
  Error: string | null;
}

export interface CodeReviewOnboardingCompleteRequest {
  OrgUUID: string;
  done: 1;
}

export interface CodeReviewOnboardingCompleteResponse {
  success: boolean;
  Error: string | null;
}

export function getCodeReviewOnboardingStatus(
  payload: CodeReviewOnboardingStatusRequest
) {
  return postWithAuth(onboardingStatusEndpoint, payload);
}

export function setCodeReviewOnboardingComplete(
  payload: CodeReviewOnboardingCompleteRequest
) {
  return postWithAuth(onboardingCompleteEndpoint, payload);
}
